import React from 'react';
import styled from 'styled-components';

const ProgressTrackWrapper = styled.div`
  position: relative;
`;

const ProgressBackground = styled.div<{ width?: number }>`
  height: 2px;
  max-width: 100%;
  min-width: ${({ width = 100 }) => width}px;
  background-color: #b5b5b5;
`;

const ProgressBarLine = styled.div<{ progress: number }>`
  position: absolute;
  height: 2px;
  background-color: #404040;

  transition-property: width;
  transition-duration: 0.5s;

  max-width: 100%;
  width: ${({ progress = 0 }) => (progress >= 96 ? `100%` : `${progress}%`)};
`;

interface ProgressTrackProps {
  progress: number;
  width?: number;
}

export const ProgressTrack = ({ progress, width }: ProgressTrackProps) => (
  <ProgressTrackWrapper>
    <ProgressBarLine progress={progress} />
    <ProgressBackground width={width} />
  </ProgressTrackWrapper>
);
